"use strict";

$(document).ready(function () {
  var lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy-images" // ... more custom settings?

  });
  AOS.init({
    once: true,
    disable: function disable() {
      var maxWidth = 800;
      return window.innerWidth < maxWidth;
    }
  });

  if ($(".grid-masnory").length) {
    $(window).on("load", function () {
      setTimeout(function () {
        $(".grid-masnory").masonry({
          itemSelector: '.grid-masnory-item',
          gutter: '.grid-masnory-gutter-sizer',
          percentPosition: true
        });
      }, 300);
    });
  }

  $(".scroll-top").on("click", function (e) {
    e.preventDefault();
    $("html, body").animate({
      scrollTop: 0
    }, 600);
  });
  $(window).bind('scroll', function () {
    if ($(window).scrollTop() > 10) {
      $('.nav').addClass('fixed');
    } else {
      $('.nav').removeClass('fixed');
    }
  });

  if ($('.object__title--fixed').length) {
    $(window).bind('scroll', function () {
      if ($(window).scrollTop() > $(".object__title").offset().top + $(".object__title").outerHeight()) {
        $('.object__title--fixed').addClass('open');
      } else {
        $('.object__title--fixed').removeClass('open');
      }
    });
  }

  if ($(".object-popular-slider").length) {
    $(".object-popular-slider").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1
    });
  }

  if ($(".home-top-slider").length) {
    $(".home-top-slider").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      autoplay: true,
      fade: true,
      autoplaySpeed: 5000
    });
  } // if ($(".partners-slider").length) {
  //     $(".partners-slider").slick({
  //         arrows: false,
  //         slidesToShow: 6,
  //         slidesToScroll: 1,
  //         responsive: [
  //             {
  //                 breakpoint: 1024,
  //                 settings: {
  //                     slidesToShow: 5,
  //                 }
  //             },
  //             {
  //                 breakpoint: 800,
  //                 settings: {
  //                     slidesToShow: 4
  //                 }
  //             },
  //             {
  //                 breakpoint: 767,
  //                 settings: "unslick"
  //             }
  //         ]
  //     })
  // }


  if ($(".recomendation-slider").length) {
    $(".recomendation-slider").slick({
      arrows: false,
      dots: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: false,
      responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      }, {
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      }]
    });
  }

  if ($(".object-info-gallery").length) {
    $(".object-info-gallery").slick({
      slidesToShow: 1,
      infinite: true
    });
  }

  $(".zoom-picture").on("click", function (e) {
    e.preventDefault();
    $(this).prev(".slider-image-small").find(".slick-current a").click();
  });
  $(".menu-toggle").on("click", function (e) {
    e.preventDefault();
    $(this).toggleClass("open");
    $(".nav__menu").slideToggle();
  });
  $(".footer__title").on("click", function () {
    if ($(this).closest(".footer__col").find(".footer__nav").length) {
      $(this).closest(".footer__col").toggleClass("open");
    }
  });

  if ($(".single-select").length) {
    $('.single-select').select2({
      minimumResultsForSearch: -1,
      placeholder: 'Wybierz',
      allowClear: true
    });
  }

  if ($(".multiple-select").length) {
    $('.multiple-select').each(function(){
      $(this).select2({
        minimumResultsForSearch: -1,
        multiple: true,
        closeOnSelect: false,
        placeholder: $(this).attr("placeholder")
      });
    })

  }

  $(".show-more-options").on("click", function (e) {
    e.preventDefault();
    $(".home-top-form__outer").addClass("show-more-content");
    $(".more-options-toggle").removeClass("more-options");
    $(".show-more-options").hide();
  });
  $(".hide-more-options").on("click", function (e) {
    e.preventDefault();
    $(".more-options-toggle").addClass("more-options");
    $(".show-more-options").show();
    $(".home-top-form__outer").removeClass("show-more-content");
  });
  $("[data-disabled-input]").on("change", function () {
    if ($(this).is(":checked")) {
      $($(this).attr("data-disabled-input")).removeClass("disabled");
      $($(this).attr("data-disabled-input")).find("input").attr("disabled", false);
    } else {
      $($(this).attr("data-disabled-input")).addClass("disabled");
      $($(this).attr("data-disabled-input")).find("input").attr("disabled", true);
    }
  });
  $(".js-btn-search-advanced").on("click", function (e) {
    e.preventDefault();
    $(".advanced-search, .overlay-popup").toggleClass("open");
  });
  $(".js-btn-avaiable").on("click", function () {
    $(".object-form, .overlay-popup").toggleClass("open");
  });
  $(".js-contact-form").on("click", function (e) {
    e.preventDefault();
    $(".contact-form, .overlay-popup").toggleClass("open");
  });
  $(".popup-open").on('click', function (e) {
    e.preventDefault();
    $($(this).attr("href")).addClass("open");

    if ($($(this).attr("href")).find("#object-GoogleMap").length) {
      objectMap();
    } else if ($($(this).attr("href")).find("#list-GoogleMap").length) {
      listMap();
    }
  });
  $(".popup__close").on("click", function (e) {
    e.preventDefault();
    $(".popup").removeClass("open");
  });
  $(document).on("click", function (e) {
    var container = $(".popup__inner, .popup-open, .static");

    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $(".popup").removeClass("open");
    }
  });
  $(".js-btn-scroll").on("click", function (e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $($(this).attr("href")).offset().top - $(".nav").outerHeight()
    });
  });
  $(".hidden-info__btn").on("click", function (e) {
    e.preventDefault();
    $(this).closest(".hidden-info").addClass("visible");
  });
  $(".hall-select").on("change", function () {
    var hallNumber = $(this).find(":selected").val();
    $(".hall-select-form").hide();
    $(".hall-select-form input").addClass("ignore");

    for (var i = 1; i <= hallNumber; i++) {
      console.log(i);
      $("#hall-select-" + i).show();
      $("#hall-select-" + i).find("input").removeClass("ignore");
    }
  });
  $('#date_from').Zebra_DatePicker({
    format: 'd-m-Y',
    direction: true,
    pair: $('#date_to'),
    default_position: 'below',
    months: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
    days: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
    lang_clear_date: 'Wyczyść',
    show_select_today: true,
    onOpen: function onOpen() {
      $(".dp_today").html("Zatwierdź");
    },
    onSelect: function onSelect(date1, date2, date3, elem) {
      if ($('#date_from').val() == $('#date_to').val()) {
        $('.hours2').show();
      } else {
        $('.hours2').hide();
      }
    },
    onClear: function onClear() {
      $('.hours2').hide();
    }
  });
  $('#date_to').Zebra_DatePicker({
    direction: true,
    format: 'd-m-Y',
    default_position: 'below',
    months: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
    show_select_today: true,
    onOpen: function onOpen() {
      $(".dp_today").html("Zatwierdź");
    },
    onSelect: function onSelect(date1, date2, date3, elem) {
      if ($('#date_from').val() == $('#date_to').val()) {
        $('.hours2').show();
      } else {
        $('.hours2').hide();
      }
    },
    onClear: function onClear() {
      $('.hours2').hide();
    }
  }); // Map object

  function objectMap() {
    var mapCanvas = document.getElementById('object-GoogleMap');
    var mapOptions = {
      center: new google.maps.LatLng(mapCanvas.dataset.lat, mapCanvas.dataset.lng),
      zoom: Number(mapCanvas.dataset.zoom)
    };
    var map = new google.maps.Map(mapCanvas, mapOptions);
    var myLatLng = new google.maps.LatLng(mapCanvas.dataset.lat, mapCanvas.dataset.lng);
    var marker = new google.maps.Marker({
      position: myLatLng,
      map: map,
      icon: mapCanvas.dataset.markerstart
    });
    var directionsService = new google.maps.DirectionsService();
    var directionsDisplay = new google.maps.DirectionsRenderer({
      map: map,
      markerOptions: {
        icon: mapCanvas.dataset.markerstop
      },
      suppressMarkers: true,
      polylineOptions: {
        strokeColor: "#e85999",
        strokeOpacity: 0.9,
        strokeWeight: 3
      }
    });
    var infoWindow = new SnazzyInfoWindow({
      marker: marker,
      content: mapCanvas.dataset.markercontent
    });
    $('#object-map-form').submit(function (e) {
      e.preventDefault();
      $('#object-map-form-results').text('');

      if ($('#directionAddress').val() == '') {
        $('#object-map-form-results').text('Pole jest wymagane.');
        return false;
      }

      showDirection();
      return false;
    });
    var markersStop = [];

    var showDirection = function showDirection() {
      var request = {
        origin: $('#directionAddress').val(),
        destination: mapCanvas.dataset.lat + "," + mapCanvas.dataset.lng,
        travelMode: google.maps.DirectionsTravelMode.DRIVING
      };

      if (markersStop.length > 0) {
        markersStop.forEach(function (item) {
          item.setVisible(false);
        });
      }

      directionsService.route(request, function (result, status) {
        if (status == google.maps.DirectionsStatus.OK) {
          directionsDisplay.setDirections(result);
          var marker = new google.maps.Marker({
            position: new google.maps.LatLng(result.routes[0].overview_path[0].lat(), result.routes[0].overview_path[0].lng()),
            map: map,
            icon: mapCanvas.dataset.markerstop
          });
          markersStop.push(marker);
          map.fitBounds(result.routes[0].bounds);
          $('#object-map-form-results').text(result.routes[0].legs[0].distance.text + ' / ' + result.routes[0].legs[0].duration.text);
        } else {
          $('#object-map-form-results').text('Nie znaleziono adresu początkowego.');
          return false;
        }
      });
    };
  }

  jQuery.extend(jQuery.validator.messages, {
    required: "Pole obowiązowe",
    remote: "Please fix this field.",
    email: "Please enter a valid email address.",
    url: "Please enter a valid URL.",
    date: "Please enter a valid date.",
    dateISO: "Please enter a valid date (ISO).",
    number: "Please enter a valid number.",
    digits: "Please enter only digits.",
    creditcard: "Please enter a valid credit card number.",
    equalTo: "Please enter the same value again.",
    accept: "Please enter a value with a valid extension.",
    maxlength: jQuery.validator.format("Please enter no more than {0} characters."),
    minlength: jQuery.validator.format("Please enter at least {0} characters."),
    rangelength: jQuery.validator.format("Please enter a value between {0} and {1} characters long."),
    range: jQuery.validator.format("Please enter a value between {0} and {1}."),
    max: jQuery.validator.format("Please enter a value less than or equal to {0}."),
    min: jQuery.validator.format("Please enter a value greater than or equal to {0}.")
  });
  $(".js-validate").each(function () {
    $(this).validate({
      ignore: ".ignore",
      rules: {
        hiddenRecaptcha: {
          required: function required() {
            if (grecaptcha.getResponse() == '') {
              return true;
            } else {
              return false;
            }
          }
        }
      },
      errorPlacement: function errorPlacement(error, element) {
        if (element.attr("type") == "checkbox") {
          if ($(element).closest(".checkbox-wrap").length) {
            $(element).closest(".checkbox-wrap").append(error);
          } else if ($(element).closest(".input-checkbox").length) {
            $(element).closest(".input-checkbox").append(error);
          }
        } else {
          error.insertAfter(element);
        }
      }
    });
  });
  $(".text-box iframe").each(function() {
    $(this).wrap( "<div class='videoWrapper'></div>" );
  })
  $("#hour_from").on("change", function () {
    var current = $(this).find(":selected").val();
    $("#hour_to option").attr("disabled", false);
    var check = false;
    $("#hour_to option").each(function () {
      if ($(this).val() == current && !check) {
        $(this).attr("disabled", true);
        check = true;
      } else if (check) {
        $(this).attr("disabled", false);
      } else {
        $(this).attr("disabled", true);
      }
    });
    $("#hour_to option").attr("selected", false);
    $("#hour_to option").each(function () {
      if ($(this).val() == current) {
        $(this).next().attr("selected", true);
      }
    });
    $("#hour_to").trigger('change');
  });
  $("#hour_to").on("change", function () {
    var current = $(this).find(":selected").val();
    $("#eventHourFrom option").attr("disabled", false);
    var check = false;
    $("#eventHourFrom option").each(function () {
      if ($(this).val() == current && !check) {
        $(this).attr("disabled", true);
        check = true;
      } else if (check) {
        $(this).attr("disabled", true);
      } else {
        $(this).attr("disabled", false);
      }
    });
    $("#eventHourFrom").trigger('change');
  });
  $(".select-distance .current").on("click", function () {
    $(this).closest(".select-distance").toggleClass("open");
  });
  $(".select-distance input:radio").on("change", function () {
    $(".select-distance .current").html($(this).attr("title"));
    $(".select-distance").removeClass("open");
  });
  $(".select-distance input:radio").each(function() {
    if ($(this).is(":checked")) {
      $(".select-distance .current").html($(this).attr("title"));
    }
  })
  $(document).mouseup(function (e) {
    var container = $(".select-distance");

    if (!container.is(e.target) && container.has(e.target).length === 0) {
      container.removeClass("open");
    }
  });
  $(".breadcrumbs__item").on("click", function () {
    if ($(this).find(".breadcrumbs__toggle")) {
      $(this).toggleClass("open");
    }
  });
  $.widget("custom.catcomplete", $.ui.autocomplete, {
    _create: function _create() {
      this._super();

      this.widget().menu("option", "items", "> :not(.ui-autocomplete-category)");
    },
    _renderMenu: function _renderMenu(ul, items) {
      var that = this,
          currentCategory = "";
      $.each(items, function (index, item) {
        var li;

        if (item.category != currentCategory) {
          ul.append("<li class='ui-autocomplete-category'>" + item.category + "</li>");
          currentCategory = item.category;
        }

        li = that._renderItemData(ul, item);

        if (item.category) {
          li.attr("aria-label", item.category + " : " + item.label);
          li.attr("data-type", item.category);
        }
      });
    }
  });

  if ($(".autocomplete-city").length) {
    $(".autocomplete-city").each(function () {
      $(this).catcomplete({
        source: $(this).attr("data-url"),
        appendTo: "#autocompleteBox",
        select: function select(event, ui) {
          $(this).val(ui.item ? ui.item : " ");
          $(this).removeClass("open");
          if (ui.item.category == "Województwo" || ui.item.category == "Miasto") {
            $('.select-distance').show()
          } else {
            $('.select-distance').hide()
          }
        },
        open: function open(event, ui) {
          $(this).addClass("open");
        },
        close: function close(event, ui) {
          $(this).removeClass("open");
        }
      });
    });
  }

  $(".scroll-next").on("click", function (e) {
    e.preventDefault();
    $("html, body").animate({
      scrollTop: $(this).closest(".add-object__item").next().offset().top - $(".nav").outerHeight()
    }, 600);
  });
  $(".scroll-form").on("click", function (e) {
    e.preventDefault();
    $($(this).attr("href")).find(".form-wrap:first-child input").focus();
  });

  if ($(".slick-big").length) {
    $('.slick-big').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      asNavFor: '.slick-thumb',
      lazyLoad: 'ondemand'
    });
    $('.slick-thumb').slick({
      slidesToShow: 9,
      slidesToScroll: 1,
      asNavFor: '.slick-big',
      dots: false,
      focusOnSelect: true,
      lazyLoad: 'ondemand',
      responsive: [{
        breakpoint: 1200,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 1,
          variableWidth: true
        }
      }, {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          variableWidth: true
        }
      }, {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          variableWidth: true
        }
      }]
    });
  }

  if ($(".slider-image-small").length) {
    $(".slider-image-small").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      infinite: false,
      lazyLoad: 'ondemand'
    });
  }

  $(".js-hidden-elements-btn").on("click", function () {
    $(this).fadeOut();
    $(this).closest(".object-features").find(".hidden-elements").slideDown();
  });
  $(".js-opinion-toggle").on("click", function () {
    $(this).fadeOut();
    $(this).closest(".object-opinion-list").find(".hidden-elements").slideDown();
  });

  if ($('.object__right').length) {
    $(window).on("load", function(){
      var sidebar = new StickySidebar('.object__right', {
        topSpacing: 100,
        minWidth: 1024
      });
    })

  }

  $.fn.isInViewport = function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  if ($('.avaiable-top').length) {
    $(window).on('resize scroll', function () {
      if ($('.avaiable-top').isInViewport() || $("#avaiable-form").isInViewport()) {
        $(".btn-avaiable-mobile").removeClass("open");
      } else {
        $(".btn-avaiable-mobile").addClass("open");
      }
    });
  }

});

function listMap() {
  var mapCanvas = document.getElementById('list-GoogleMap');
  var mapOptions = {
    center: new google.maps.LatLng(mapCanvas.dataset.lat, mapCanvas.dataset.lng),
    zoom: Number(mapCanvas.dataset.zoom)
  };
  var map = new google.maps.Map(mapCanvas, mapOptions);
  var myLatLng = new google.maps.LatLng(mapCanvas.dataset.lat, mapCanvas.dataset.lng);
  var markers = document.querySelectorAll(".marker-map");

  for (var i = 0; i < markers.length; i++) {
    var marker = new google.maps.Marker({
      position: new google.maps.LatLng(markers[i].getAttribute('data-lat'), markers[i].getAttribute('data-lng')),
      map: map,
      icon: markers[i].getAttribute('data-icon')
    });
    var infoWindow = new SnazzyInfoWindow({
      marker: marker,
      closeWhenOthersOpen: true,
      content: markers[i].getAttribute('data-markercontent')
    });
  }
}
$(".object-thumb-vertical__bottom--dots").on("click", function(){
  $(this).closest(".object-thumb-vertical__bottom").addClass("open");
})